/**
 * @generated SignedSource<<4f45121549982901de5c55a872b854e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleNotificationsPayload",
    "kind": "LinkedField",
    "name": "toggleNotifications",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Error",
        "kind": "LinkedField",
        "name": "error",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery_toggleNotificationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxQuery_toggleNotificationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaadc8aeefddb016f6d30d1fc2aa457b",
    "id": null,
    "metadata": {},
    "name": "InboxQuery_toggleNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation InboxQuery_toggleNotificationsMutation(\n  $input: ToggleNotificationsInput!\n) {\n  toggleNotifications(input: $input) {\n    ok\n    error {\n      message\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b4456f8328c5422299dedfe5170878a0";

module.exports = node;
